import styled from "styled-components"

export const Form = styled.form`
    width: 310px;
    margin-top: 20px;
    text-align: center;
`